import React, { FC, useEffect, useState } from 'react';

import Popover from 'antd/es/popover';

import { useBreakpoint } from '@contexts/breakpoints';
import useFlightGuests from '@components/ui/guest-box/guest-box-flight/useFlightGuests';
import { initialGuestInfo } from '@components/views/flight/constants';
import useSearchBar from '@contexts/searchbar';
import { FlightSearchBarActionType } from '@contexts/searchbar/types/flight';
import CustomIcon from '@components/utils/CustomIcon';
import { DownArrowIcon, PersonIcon } from '@assets/icons';
import { FlightGuestProps } from '@components/views/flight/types';
import Drawer from '@components/Drawer';
import ResponsiveApplyButton from '@components/views/components/listing/drawer/ResponsiveApplyButton/ResponsiveApplyButton';
import { useSearchParamsToQuery } from '@hooks/useSearchParamsToQuery';

import { Icon, InputWrapper, StyledInput, Wrapper } from './styled';
import Guests from './guests';

interface IFlightGuestBox {
  isListingPage?: boolean;
}

const FlightGuestBox: FC<IFlightGuestBox> = ({ isListingPage }) => {
  const { dispatch } = useSearchBar();
  const query = useSearchParamsToQuery();

  const guests: FlightGuestProps = {
    numberOfAdultGuests:
      Number(query.ADT) || initialGuestInfo.numberOfAdultGuests,
    numberOfChildGuests:
      Number(query.CHD) || initialGuestInfo.numberOfChildGuests,
    numberOfInfantGuests:
      Number(query.INF) || initialGuestInfo.numberOfChildGuests,
  };

  const {
    numberOfAdultGuests,
    numberOfChildGuests,
    numberOfInfantGuests,
    removeAdult,
    addAdult,
    removeChild,
    addChild,
    removeInfant,
    addInfant,
    errorMessages,
  } = useFlightGuests(guests || initialGuestInfo);

  useEffect(() => {
    dispatch({
      type: FlightSearchBarActionType.SET_GUESTS,
      payload: {
        numberOfAdultGuests,
        numberOfChildGuests,
        numberOfInfantGuests,
      },
    });
  }, [
    dispatch,
    numberOfAdultGuests,
    numberOfChildGuests,
    numberOfInfantGuests,
  ]);
  const { xl } = useBreakpoint();
  const [isHeaderOpen, setIsHeaderOpen] = useState<boolean>(false);
  const handleHeaderOpen = () => setIsHeaderOpen((oldState) => !oldState);

  return (
    <>
      {xl ? (
        <Wrapper>
          <Popover
            placement='bottomLeft'
            trigger='click'
            styles={{ body: { borderRadius: 12 } }}
            content={
              <Guests
                numberOfAdultGuests={numberOfAdultGuests}
                numberOfChildGuests={numberOfChildGuests}
                numberOfInfantGuests={numberOfInfantGuests}
                onRemoveAdult={removeAdult}
                onAddAdult={addAdult}
                onRemoveChild={removeChild}
                onAddChild={addChild}
                onRemoveInfant={removeInfant}
                onAddInfant={addInfant}
                errorMessages={errorMessages}
              />
            }
          >
            <InputWrapper>
              <Icon isListingPage={isListingPage}>
                <CustomIcon
                  fontSize={18}
                  paletteColor='grey500'
                  icon={PersonIcon}
                />
              </Icon>
              <StyledInput
                isListingPage={isListingPage}
                placeholder='Yolcu Seçimi'
                value={`${
                  numberOfAdultGuests +
                  numberOfChildGuests +
                  numberOfInfantGuests
                } ${' '}Yolcu`}
                readOnly
                suffix={
                  <CustomIcon
                    fontSize={18}
                    paletteColor='grey800'
                    icon={DownArrowIcon}
                  />
                }
              />
            </InputWrapper>
          </Popover>
        </Wrapper>
      ) : (
        <Wrapper>
          <Drawer
            title='Yolcu Sayısı'
            open={isHeaderOpen}
            onClose={handleHeaderOpen}
            placement='top'
            footer={
              <ResponsiveApplyButton
                title='Uygula'
                onClick={handleHeaderOpen}
              />
            }
          >
            <Guests
              numberOfAdultGuests={numberOfAdultGuests}
              numberOfChildGuests={numberOfChildGuests}
              numberOfInfantGuests={numberOfInfantGuests}
              onRemoveAdult={removeAdult}
              onAddAdult={addAdult}
              onRemoveChild={removeChild}
              onAddChild={addChild}
              onRemoveInfant={removeInfant}
              onAddInfant={addInfant}
              errorMessages={errorMessages}
              handleHeaderOpen={handleHeaderOpen}
            />
          </Drawer>

          <InputWrapper isOpen={isHeaderOpen} onClick={handleHeaderOpen}>
            <Icon>
              <CustomIcon
                fontSize={18}
                paletteColor='grey500'
                icon={PersonIcon}
              />
            </Icon>
            <StyledInput
              placeholder='Yolcu Seçimi'
              value={`${
                numberOfAdultGuests + numberOfChildGuests + numberOfInfantGuests
              } ${' '}Yolcu`}
              readOnly
              suffix={
                <CustomIcon
                  fontSize={18}
                  paletteColor='grey800'
                  icon={DownArrowIcon}
                />
              }
            />
          </InputWrapper>
        </Wrapper>
      )}
    </>
  );
};

export default FlightGuestBox;
